import {Component, Input, OnInit} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {NgForm} from '@angular/forms';
import {GetDataService} from '../../../shared/get-data.service';
import {JobsDataService} from '../jobs-data.service';
import {SelectFieldsTable} from '../create-job/select-fields.table';
import {Options} from 'select2';
import {Select2OptionData} from 'ng-select2';
import {filter} from 'rxjs/operators';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {DropdownDataTable} from '../../../../crm/shared/dropdown-data.table';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-jobs-list',
    templateUrl: './jobs-list.component.html',
    styleUrls: ['./jobs-list.component.scss'],
    providers: [SelectFieldsTable, SelectLocationTable, DropdownDataTable]
})
export class JobsListComponent implements OnInit {

    constructor(private http: HttpClient,
                private getDataService: GetDataService,
                private jobsDataService: JobsDataService,
                private selectFields: SelectFieldsTable,
                private locationSelect: SelectLocationTable,
                private dropdownSelect: DropdownDataTable,
                private route: ActivatedRoute) {
    }

    // Select 2 Inputs Options
    public singleOption: Options;
    public multiOptions: Options;


    order: string = 'desc';
    sort: string = 'jobPostingDate';

    sortingValues = this.dropdownSelect.jobsSorting;

    filterDomains: any = [];

    // Pagination
    page = 1; // Page selected at start
    pageSize = 9; // How many post per page
    selectPageSize = [9, 18, 45];
    totalElements: number;
    formPageNumber = 0;

    // Filter
    filterRecentJobs = false;
    filterData: object;

    // Search Job - Object
    jobCriteriaData: any = {};
    // Search Job Inputs
    jobTitle: string;
    locations = this.locationSelect.Countries;
    locationsArrayValues: Array<any>;
    city: Array<any> = [];
    selectedCountry: any = '';
    selectedCity: any = [];
    relocationPossibility: false;
    relocationPackageIncluded: false;
    experienceLevel: any = '';
    jobDisponibility: any = '';
    workType: any = '';
    contractType: any = '';
    activitySector: any = '';
    activitySubSector: any = '';
    departments: Array<string> = [];
    selectedDepartments: any = [];
    category: Array<Select2OptionData>;
    selectedCategory: any = ''
    selectStudies: ({ valueName: string; name: string } | string)[];
    selectedStudies: any = '';
    languages: any = [];
    selectedLanguages: any = '';
    selectedLanguagesLevel: any = '';
    driveLicense: Array<Select2OptionData>;
    selectedDriveLicense: any = [];
    availableForTraveling: any = '';
    totalExperience: number;
    selectedSimilarExpDepartments: any = '';
    selectedSimilarExpYears: number;
    legalWorkPermitMandatory: false;
    selectBonus: ({ valueName: string; name: string } | string)[];
    selectedBonus: any = '';
    selectOtherBenefits: Array<string>;
    selectedOtherBenefits: any = [];
    selectCareerPossibility: Array<Select2OptionData>;
    selectedCRP: any = [];
    selectWorkProgram: ({ valueName: string; name: string } | string)[];
    selectedWP: any = '';
    selectWorkSpace: ({ valueName: string; name: string } | string)[];
    selectedWS: any = '';
    physicalType: any = '';
    physicalDetail: any = '';

    filteredJobs: any = [];
    recentJobs = [];

    foreignLanguages: string;
    similarExperience: string;
    physicalEffort: string;


    // Domenii, Subdomenii & Categorii
    selectedDomain = '';
    Domains: any = this.dropdownSelect.domains;

    subdomains: any;
    subDomainsArray: any = [];

    categories: any = [];
    categoriesArray: any = [];

    selectSubdomains: string;

    selected: any;

    finalCategories: any = [];

    selectedCategories: any;

    filterActive: boolean = false;


    ngOnInit() {
        
        this.departments = this.selectFields.departments;
        this.category = this.selectFields.selectCategory;
        this.selectStudies = this.selectFields.selectStudies;
        this.languages = this.selectFields.languages;
        this.driveLicense = this.selectFields.driveLicense;
        this.selectBonus = this.selectFields.selectBonus;
        this.selectOtherBenefits = this.selectFields.selectOtherBenefits;
        this.selectCareerPossibility = this.selectFields.selectCareerPossibility;
        this.selectWorkProgram = this.selectFields.selectWorkProgram;
        this.selectWorkSpace = this.selectFields.selectWorkSpace;
        this.filterDomains.activitySector = '';

        // Domains Loop
        // const domainsArray = [];
        // this.domains.forEach((value) => {
        //     const domain = value.name;
        //     domainsArray.push(domain);
        // });
        // this.domainsArrayValues = domainsArray;

        // Location Loop
        const locationArray = [];
        this.locations.forEach((value) => {
            const country = value.name;
            locationArray.push(country);
        });
        this.locationsArrayValues = locationArray;


        // Select 2 Options
        this.singleOption = {
            width: '100%',
            allowClear: true
        };
        this.multiOptions = {
            width: '100%',
            multiple: true,
            allowClear: true
        };

        // this.jobCall();

        this.route.queryParams
        .subscribe(params => {
            if(params === undefined){
                this.jobCall();
            }else{
                this.check();
            }
        })

    }

    resetSearch() {
        this.jobTitle = '';
        this.selectedCountry = '';
        this.selectedCity = '';
        this.relocationPossibility = undefined;
        this.relocationPackageIncluded = undefined;
        this.workType = '';
        this.contractType = '';
        this.experienceLevel = '';
        this.jobDisponibility = '';
        this.filterDomains.activitySector = '';
        this.activitySubSector = '';
        this.selectedDepartments = '';
        this.selectedCategory = '';
        this.selectedStudies = '';
        this.selectedDriveLicense = '';
        this.availableForTraveling = '';
        this.totalExperience = undefined;
        this.legalWorkPermitMandatory = undefined;
        this.selectedBonus = '';
        this.selectedOtherBenefits = '';
        this.selectedCRP = '';
        this.selectedWP = '';
        this.selectedWS = '';


        this.jobCriteriaData = {};
        this.jobsDataService.getFilteredJobs(this.pageSize, this.page, this.sort, this.order, this.jobCriteriaData).subscribe(jobs => {
            this.filteredJobs = jobs;
            console.log('jobs', jobs)
            this.totalElements = this.filteredJobs.totalElements;
            this.filterRecentJobs = false;
        }, error => {
        });
    }


    changeDomain(domain: any) {
        this.subDomainsArray = [];
        this.selectSubdomains = undefined;
        this.subdomains = this.Domains.find((dmn: any) => dmn.name === domain.target.value).subdomains;
        this.subdomains.forEach(subdomain => {
            this.subDomainsArray.push(subdomain.name); 
        })
    }

    changeSubDomain(subdomain: any) {
        this.selected = subdomain;
        this.selectSubdomains = undefined;
        if (this.selected) {
            this.categories = this.Domains
                .find((dmn: any) => dmn.name === this.selectedDomain).subdomains
                .find((subDm: any) => subDm.name === this.selected).categories;
            this.categoriesArray = this.categories;
        }
    }

    changeCountry(country: any) {
        this.city = this.locations.find((loc: any) => loc.name === country).cities;
    }

    jobCall() {
        this.jobCriteriaData = {
            jobTitle: this.jobTitle !== ''? this.jobTitle : undefined,
            country: this.selectedCountry !== '' ? this.selectedCountry : undefined,
            city: this.selectedCity !== null ? (this.selectedCity.length > 0 ? this.selectedCity : undefined) : undefined,
            relocationPossibility: this.relocationPossibility !== false ? this.relocationPossibility : undefined,
            relocationPackageIncluded: this.relocationPackageIncluded !== false ? this.relocationPackageIncluded : undefined,
            workType: this.workType !== '' ? this.workType : undefined,
            contractType: this.contractType !== '' ? this.contractType : undefined,
            experienceLevel: this.experienceLevel !== '' ? this.experienceLevel : undefined,
            jobDisponibility: this.jobDisponibility !== '' ? this.jobDisponibility : undefined,
            activitySector: this.selectedDomain !== '' ? this.selectedDomain : undefined,
            activitySubSector: this.selectedDomain !== '' ? this.selectSubdomains : undefined,
            category: this.selectedDomain !== '' ? this.selectedCategories : undefined,
            department: this.selectedDepartments !== null ? (this.selectedDepartments.length > 0 ? this.selectedDepartments : undefined) : undefined,
            studies: this.selectedStudies !== '' ? this.selectedStudies : undefined,
            driverLicense: this.selectedDriveLicense !== null ? (this.selectedDriveLicense.length > 0 ? this.selectedDriveLicense : undefined) : undefined,
            availableForTraveling: this.availableForTraveling !== '' ? this.availableForTraveling : undefined,
            totalExperience: this.totalExperience !== 0 ? this.totalExperience : undefined,
            legalWorkPermitMandatory: this.legalWorkPermitMandatory !== false ? this.legalWorkPermitMandatory : undefined,
            bonus: this.selectedBonus !== '' ? this.selectedBonus : undefined,
            otherBenefits: this.selectedOtherBenefits !== null ? (this.selectedOtherBenefits.length > 0 ? this.selectedOtherBenefits : undefined) : undefined,
            careerPossibility: this.selectedCRP !== null ? (this.selectedCRP.length > 0 ? this.selectedCRP : undefined) : undefined,
            workProgram: this.selectedWP !== '' ? this.selectedWP : undefined,
            workSpace: this.selectedWS !== '' ? this.selectedWS : undefined,
            language: (this.foreignLanguages !== undefined && this.foreignLanguages !== '') ? [this.foreignLanguages] : undefined,
            similarExperienceDepartment: (this.similarExperience !== undefined && this.similarExperience !== '') ? [this.similarExperience] : undefined,
            physicalEffortType: this.physicalEffort !== '' ? this.physicalEffort : undefined
        }

        console.log(this.jobCriteriaData, 'jobs req')

        this.jobsDataService.getFilteredJobs(this.pageSize, this.page, this.sort, this.order, this.jobCriteriaData).subscribe(jobs => {
            this.filteredJobs = jobs;
            console.log('jobs', jobs)
            this.totalElements = this.filteredJobs.totalElements;
            this.filterRecentJobs = false;
        }, error => {
        });
    }

    showRecentJobs() {
        this.jobsDataService.showRecentJobs().subscribe((data: any) => {
            this.filterRecentJobs = true;
            this.recentJobs = data;
        })
    }

    onPageChange(page: number) {
        this.page = page;
        this.jobCall();
    }

    onSizeChange(event: any) {
        this.pageSize = event.target.value;
        this.page = 1;
        this.jobCall();
    }

    onSortChange(event: any) {
        this.sort = event.target.value;
        this.page = 1;
        this.jobCall();
    }

    onOrderChange(event: any) {
        this.order = event.target.value;
        this.page = 1;
        this.jobCall();
    }

    check(){
        this.route.queryParams
      .subscribe(params => {

        const job={
            city: params.localitate != null ? [params.localitate] : undefined,
            activitySector: params.domeniu != null ? params.domeniu : undefined,
            activitySubsector: params.subdomeniu != null ? params.subdomeniu : undefined,
            department: params.departamente != null ? [params.departamente] : undefined
        }
        console.log('VERIFICA',job);

        this.jobsDataService.getFilteredJobs(this.pageSize, this.page, this.sort, this.order, job).subscribe(jobs => {
            console.log('jobs', jobs)
            this.filteredJobs = jobs;
            this.totalElements = this.filteredJobs.totalElements;
            this.filterRecentJobs = false;
        }, error => {
            console.log('nu', error);
        });
      }
    );
    }
}
